export default {
    organizations: {
        relations: {
            staff: { inverse: 'organization' },
        }
    },

    athletes: {
        relations: {
            videos: { inverse: 'owner' },
        }
    },
}